import { Actions, createEffect, ofType } from '@ngrx/effects'
import { map, switchMap, withLatestFrom } from 'rxjs'

import { Injectable } from '@angular/core'
import { ChangeRequestActions } from '../actions/change-request.actions'
import { ChangeItemType, ChangeType } from '../../model'
import { ScopeOverviewSelectors } from '@app/features/scope-overview/store/selectors/scope-overview.selector'
import { ChangeRequestSelectors } from '../selectors/change-request.selectors'
import { Store } from '@ngrx/store'

@Injectable()
export class ChangeRequestComponentEffects {
  constructor(
    private actions$: Actions,
    private store$: Store
  ) {}

  modifyComponent$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ChangeRequestActions.modifyComponent),
      map(({ identity, parentId, changes }) =>
        ChangeRequestActions.applyChanges({
          payload: {
            changeType: ChangeType.MODIFIED,
            type: ChangeItemType.COMPONENT,
            identity,
            parentId,
            data: changes,
          },
        })
      )
    )
  )

  deleteComponent$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ChangeRequestActions.deleteComponent),
      withLatestFrom(
        this.store$.select(ChangeRequestSelectors.selectChangeItemEntities),
        this.store$.select(ScopeOverviewSelectors.selectCurrentScope),
        this.store$.select(ChangeRequestSelectors.selectCurrentChangeRequest)
      ),
      switchMap(([{ componentId }, changeItemEntities, currentScope, currentChangeRequest]) => [
        ChangeRequestActions.removeChanges({ changeItemUuid: changeItemEntities?.[componentId]?.uuid }),
        ChangeRequestActions.createChanges({
          scopeId: currentScope.identity.id,
          changeRequestId: currentChangeRequest.id,
          payload: {
            changeType: ChangeType.REMOVED,
            type: ChangeItemType.COMPONENT,
            identity: componentId,
          },
        }),
      ])
    )
  )

  revertDeletedComponent$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ChangeRequestActions.revertDeletedComponent),
      withLatestFrom(this.store$.select(ChangeRequestSelectors.selectChangeItemEntities)),
      map(([{ componentId }, changeItemEntities]) =>
        ChangeRequestActions.removeChanges({ changeItemUuid: changeItemEntities?.[componentId]?.uuid })
      )
    )
  )
}
